"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./init");
const rum_1 = require("@yandex-int/pythia-libs/lib/rum");
const geo_1 = require("@yandex-int/pythia-libs/lib/geo");
const video_1 = __importDefault(require("../polls/video"));
const embed_1 = require("./embed");
(0, rum_1.initCounters)({
    page: 'video',
    tld: (0, geo_1.getTLDFromHost)(location.hostname),
    version: VERSION
});
(0, embed_1.embed)(video_1.default);
(0, rum_1.sendJSFrameworkInited)();
// @ts-ignore
if (module.hot) {
    // @ts-ignore
    module.hot.accept(['../polls/video'], () => {
        const Poll = require('../polls/video').default;
        (0, embed_1.embed)(Poll);
    });
}
